import { AggregateVersion } from "./aggregateVersion.model";

/**
 * An engagement's config history (MPN-1334). No `run_count`: nothing pins an engagement version
 * the way an IngestRun pins a field-map one, so the field would be a permanent zero.
 */
export type EngagementConfigVersion = AggregateVersion;

export interface EngagementConfigVersionSnapshot {
  id: number;
  version_number: number;
  created: string;
  schema_version: number;
  trigger: string | null;
  changed_by: { name: string; email: string } | null;
  /** The aggregate exactly as captured — the reproduction case for a support ticket. */
  snapshot: Record<string, unknown>;
}

/** Engagement-specific triggers on top of the universal three. */
export const ENGAGEMENT_TRIGGER_LABELS: Record<string, string> = {
  impersonated_edit: "acting as another user",
  ad_approved: "an ad was approved",
  ad_changes_requested: "changes were requested on an ad",
  ad_review_requested: "an ad was sent for review",
  audience_recalculated: "the audience was recalculated",
  went_live: "first publish went live",
};

/**
 * One line on the merged Activity timeline (MPN-1334) — a config version or a background job.
 *
 * Merged at read: versions and jobs live in separate tables because a publish applies the config
 * rather than changing it. They belong together only in presentation, because "the budget changed
 * at 2pm and a publish ran at 3pm" is a single question.
 */
export interface EngagementActivityEntry {
  kind: "version" | "job";
  id: number;
  at: string;
  title: string;
  actor: { name: string; email: string } | null;
  trigger: string | null;
  /** Present for kind === "version", so the row can expand into its diff. */
  version: EngagementConfigVersion | null;
  job_type: string | null;
  job_status: string | null;
}
